import React, { useRef } from 'react';
import { ConfigProvider } from 'antd';
import { useLocation } from 'react-router';
import AppContext from './components/infrastructure/appContext';
import { MainLayout } from './home/mainlayout';
import './home/index.css'
import { Switch } from 'react-router-dom';
import { Route } from 'react-router-dom';
import Login from './account/login/index';
import { ForgetPassword } from './account/forgetPassword';
import { ResetPassword } from './account/resetPassword';
import { ChangeContact } from './account/login/changeContact';
import { useState } from 'react';
import { IComponentItem, IPanelInfo, IUserInfo } from './components/infrastructure/models';
import { ErrorBoundary } from './home/errorBoundary';
import { isMobile } from 'react-device-detect';
import { VersionUpdateNotificationContainer } from './components/infrastructure/versionUpdateNotificationContainer';
import { Faq } from './home/faq';
import { Help } from './home/help';
import { jalaliLocale } from './home/jalaliLocale';
import dayjs from 'dayjs';
import jalaliday from 'jalali-plugin-dayjs';

dayjs.extend(jalaliday);
dayjs.calendar('jalali');
dayjs.locale('fa');

interface AppState {
    userInfo?: IUserInfo | null;
    panelInfo: IPanelInfo;
    menuItems: IComponentItem[];
    sidebarCollapsed: boolean;
    blockLayout: boolean;
    blockTitle?: string;
}

export default function App() {
    const parseParams = function (): { [key: string]: string } {
        let params: { [key: string]: string } = {};
        new URLSearchParams(location.search).forEach((v, k) => {
            params[k.toLowerCase()] = v;
        });
        return params;
    }

    const [state, setState] = useState<AppState>({ panelInfo: { data: [] }, menuItems: [], sidebarCollapsed: isMobile, blockLayout: false });

    const layoutBlockCount = useRef(0);

    const setInfo = (menuItems: IComponentItem[], userInfo?: IUserInfo | null) => {
        const newState = { ...state, userInfo, menuItems }
        setState(newState);
    };

    const getUserInfo = () => {
        const { userInfo } = state;
        return userInfo;
    };

    const getMenuItems = () => {
        const { menuItems } = state;
        return menuItems;
    };

    const getPanelInfo = () => {
        const { panelInfo } = state;
        return panelInfo;
    };

    const setSidebarCollapsed = (sidebarCollapsed: boolean) => {
        setState({ ...state, sidebarCollapsed });
    };

    const setBlockLayout = (blockLayout: boolean, blockTitle?: string) => {
        layoutBlockCount.current = blockLayout ? layoutBlockCount.current + 1 : layoutBlockCount.current - 1;
        setState({ ...state, blockLayout: layoutBlockCount.current > 0, blockTitle });
    };

    const setPanelInfo = (panelInfo: IPanelInfo) => {
        const newState = { ...state, panelInfo };
        setState(newState);
    };

    const location = useLocation();

    React.useEffect(() => { }, [location]);

    const params = parseParams();

    window.history.replaceState(null, '', location.pathname);

    for (let key in localStorage)
        if (key !== "LoginName" && !key.startsWith("homeMenu_"))
            localStorage.removeItem(key);

    return (
        <ConfigProvider locale={jalaliLocale} direction="rtl" >
            <AppContext.Provider value={{
                params: params,
                path: location.pathname,
                getUserInfo: getUserInfo,
                getMenuItems: getMenuItems,
                sidebarCollapsed: state.sidebarCollapsed,
                blockLayout: state.blockLayout,
                blockTitle: state.blockTitle,
                setInfo,
                setSidebarCollapsed,
                getPanelInfo,
                setPanelInfo,
                setBlockLayout
            }} >
                {
                    <>
                        <VersionUpdateNotificationContainer />
                        <Switch>
                            <Route exact path='/login' component={Login} />
                            <Route exact path='/forgetpassword' component={ForgetPassword} />
                            <Route exact path='/resetpassword' component={ResetPassword} />
                            <Route exact path="/changecontact" component={ChangeContact} />
                            <Route exact path="/faq" render={() =>
                                <ErrorBoundary>
                                    <Faq />
                                </ErrorBoundary>
                            } />
                            <Route exact path="/help" render={() =>
                                <ErrorBoundary>
                                    <Help />
                                </ErrorBoundary>
                            } />
                            <Route>
                                <ErrorBoundary>
                                    <MainLayout />
                                </ErrorBoundary>
                            </Route>
                        </Switch>
                    </>
                }
            </AppContext.Provider >
        </ConfigProvider>
    );
}